import Modal from "react-modal";
import BasicButton from "./BasicButton";
import { writeTable } from "./componentModal/writeTable";
import WriteIcon from "./componentModal/WriteIcon";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { colors } from "../data/colors";
import { ModalDataType } from "../data/types/modalTypes";
import { customStyles } from "../data/styles/modalStyles";
import { HeaderTabs } from "./componentModal/HeaderTabs";
import WriteInputList from "./componentModal/WriteInputList";
import DrawingBox from "./DocumentModal/components/DrawingBox";
import { stdObject } from "../data/types/stdObject";
import WriteText from "./componentModal/WriteText";
import JSONBox from "./componentModal/JSONBox";
import TransferRecords from "./componentModal/TransferRecords";
import ImagesListBox from "./componentModal/ImagesListBox";
import useScreenSize from "../utils/getDimentions";

export default function BasicModal({
  open = false,
  data,
  close = () => {},
  children = null,
  zIndexs = { z1: 50, z2: 51 },
}: {
  open: boolean;
  data: object;
  close?: () => void;
  children?: React.ReactNode;
  zIndexs?: stdObject;
}) {
  const screenSize = useScreenSize();
  const [dimData, setDimData] = useState({
    tabs: screenSize.width - 100,
    height: screenSize.height - 100,
  });

  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [drawing, setDrawing] = useState("");
  const {
    code,
    title = false,
    intro = "",
    label = "",
    tabAction = () => {},
    tabs = [],
    inputs = [],
    tableTab = 0,
    table = [],
    table2 = [],
    tableHeaders = [],
    previous = [],
    next = [],
    isList = false,
    style = {},
    tableStyle = {},
    draw = {},
    // tdStyle = {},
    blocked = false,
    JSONdata = false,
    imagesList = {},
    inputListStyle = {},
    mainColor = colors.blue,
  } = data as ModalDataType;
  let { buttons = [] } = data as ModalDataType;
  if (
    (!code || (typeof code === "string" && !["loading"].includes(code))) &&
    buttons.length === 0
  ) {
    buttons = [{ Icon: null, label: t("p.close"), onClick: close }];
  }

  const switchTab = (index: number) => {
    tabAction(index);
    setTabIndex(index);
  };

  useEffect(() => {
    setTabIndex(0);
  }, [open]);

  useEffect(() => {
    setDimData({
      tabs: screenSize.width - 100,
      height: screenSize.height - 80,
    });
  }, [screenSize]);

  return (
    <Modal
      isOpen={open}
      onRequestClose={code !== "loading" && !blocked ? close : () => {}}
      style={customStyles({ ...zIndexs, maxHeight: dimData.height })}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          ...style,
        }}
      >
        <WriteIcon code={code} textExists={title !== "" && !!title} />
        <WriteText info={!title ? "" : title} main={true} />
        {tabs.length > 0 && (
          <HeaderTabs
            tabs={tabs}
            maxWidth={dimData.tabs}
            tabIndex={tabIndex}
            switchTab={switchTab}
            mainColor={mainColor}
          />
        )}
        {draw.code && <DrawingBox draw={draw} setDrawing={setDrawing} />}
        <WriteText info={intro} main={false} align={"left"} />
        <WriteText info={label} main={false} align={"center"} />
        {children}
        {(previous.length > 0 || next.length > 0) && (
          <TransferRecords title={title} previous={previous} next={next} />
        )}
        <WriteInputList
          inputs={inputs}
          tabs={tabs}
          tabIndex={tabIndex}
          tableTab={tableTab}
          table={tableTab > 0 ? table : []}
          tableStyle={tableStyle}
          isList={isList}
          style={inputListStyle}
          mainColor={mainColor}
        />
        {JSONdata && <JSONBox data={JSONdata} />}
        {!tableTab &&
          table.length > 0 &&
          writeTable(table, tableStyle, isList, tableHeaders)}
        {table2.length > 0 && writeTable(table2, { height: 120 })}
        {"images" in imagesList && Array.isArray(imagesList.images) && (
          <ImagesListBox data={imagesList} />
        )}
        {buttons.length > 0 && (
          <div className="buttonsBar">
            {buttons.map(
              (e, index) =>
                e && (
                  <BasicButton
                    key={index}
                    onClick={
                      drawing !== ""
                        ? () => (e.onClick as any)(drawing)
                        : (e.onClick ?? (() => {}))
                    }
                    title={e.label}
                    color={e.color}
                    style={e.style ?? {}}
                  />
                ),
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
